import {Checkout} from '../../../utils/functions';
import {DeleteCheckout} from './../../../utils/functions';

import styles from './DeleteCheckoutButton.module.css';

export const DeleteCheckoutButton = ({
    phone
}) => {
    return (
        <button className={styles.button}
                onClick={() => DeleteCheckout(phone)}
                >Видалити замовлення</button>
    )
}